var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "position-relative" }, [
    _vm.canScrollUp
      ? _c("div", {
          staticClass: "position-absolute w-100 top-shadow",
          style: _vm.topShadowStyle,
        })
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "scrollContainer",
        staticClass: "scroll-shadow-content overflow-auto position-relative",
        style: _vm.containerStyle,
        on: { scroll: _vm.handleScroll },
      },
      [_vm._t("default")],
      2
    ),
    _vm._v(" "),
    _vm.canScrollDown
      ? _c("div", {
          staticClass: "position-absolute w-100 bottom-shadow",
          style: _vm.bottomShadowStyle,
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }